(function () {
  'use strict';

  const YES = 'Ja';
  const NO = 'Nein';

  function serviceYesLabel(config) {
    const euros = Math.round((config.servicePriceCents || 15000) / 100);
    return `Ja (+${euros}€)`;
  }

  function getConfig() {
    const el = document.querySelector('[data-ostap-po-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatMoney(cents) {
    const cfg = window.T4Sconfigs || {};
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, cfg.moneyFormat || '{{amount}}');
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: cfg.cartCurrency || cfg.shopCurency || 'EUR',
    }).format(cents / 100);
  }

  /** Variant price map from Kalles `script.pr_variants_json` (cents). */
  function getVariantsPriceMap(form) {
    const scope = form || document;
    let script = scope.querySelector && scope.querySelector('script.pr_variants_json');
    if (!script) {
      const featured = form && form.closest('[data-product-featured]');
      script =
        (featured && featured.querySelector('script.pr_variants_json')) ||
        document.querySelector('script.pr_variants_json');
    }
    if (!script) return null;
    try {
      const list = JSON.parse(script.textContent);
      if (!Array.isArray(list)) return null;
      const map = Object.create(null);
      list.forEach(function (v) {
        if (v && v.id != null && v.price != null) map[String(v.id)] = Number(v.price);
      });
      return map;
    } catch (e) {
      return null;
    }
  }

  function syncAllVariantIdFields(form, id) {
    if (!form || !id) return;
    const vid = String(id);
    form.querySelectorAll('[name="id"]').forEach(function (el) {
      el.value = vid;
      if (el.tagName === 'SELECT') {
        const opt = el.querySelector('option[value="' + vid + '"]');
        if (opt) el.selectedIndex = opt.index;
      }
    });
  }

  /**
   * Selected variant id for price display.
   * Kalles keeps BOTH hidden input (often stale after Maße/Farbe) and select (usually current).
   * Prefer select; never trust the first [name=id] alone.
   */
  function getSelectedVariantId(form) {
    if (!form) return null;
    const select = form.querySelector('select[name="id"]');
    if (select && select.value) {
      syncAllVariantIdFields(form, select.value);
      return String(select.value);
    }
    const input = form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  /**
   * Current variant price in cents.
   * Prefer live variant JSON — data-product-featured.price is often stale after Stoff/Maße switch.
   */
  function getCurrentVariantPriceCents(form) {
    // Prefer UI-resolved id (Farbe + Ecke + Maße) when available — same source as ATC.
    let variantId = null;
    try {
      if (typeof resolveVariantId === 'function') variantId = resolveVariantId(form);
    } catch (e) { /* ignore */ }
    if (!variantId) variantId = getSelectedVariantId(form);

    if (variantId) {
      const map = getVariantsPriceMap(form);
      if (map && map[variantId] != null && !Number.isNaN(map[variantId])) {
        return map[variantId];
      }
      const metaVars = window.meta && window.meta.product && window.meta.product.variants;
      if (Array.isArray(metaVars)) {
        const hit = metaVars.find(function (v) {
          return String(v.id) === variantId;
        });
        if (hit && hit.price != null) return Number(hit.price);
      }
    }
    const featured = form && form.closest('[data-product-featured]');
    if (featured) {
      try {
        const data = JSON.parse(featured.getAttribute('data-product-featured'));
        if (data && data.price != null) return Number(data.price);
      } catch (e) { /* ignore */ }
    }
    return null;
  }

  function syncFeaturedPriceAttr(form, priceCents) {
    const featured = form && form.closest('[data-product-featured]');
    if (!featured || priceCents == null) return;
    try {
      const data = JSON.parse(featured.getAttribute('data-product-featured') || '{}');
      data.price = priceCents;
      featured.setAttribute('data-product-featured', JSON.stringify(data));
    } catch (e) { /* ignore */ }
  }

  function updateDisplayedPrice(form, config) {
    const priceWrap = form.closest('[data-product-featured]')?.querySelector('[data-product-price]')
      || document.querySelector('[data-product-price]');
    if (!priceWrap || !config) return;

    const baseCents = getCurrentVariantPriceCents(form);
    if (baseCents == null || Number.isNaN(baseCents)) return;

    // Always track the selected variant price (Stoff/Farbe must refresh this).
    priceWrap.dataset.ostapBasePrice = String(baseCents);
    syncFeaturedPriceAttr(form, baseCents);
    const origBase = baseCents;

    const serviceOn = form.querySelector('[data-ostap-po-checkbox="3"]')?.checked;
    const total = origBase + (serviceOn ? config.servicePriceCents : 0);
    const formatted = formatMoney(total);

    const ins = priceWrap.querySelector('ins');
    if (ins) {
      ins.textContent = formatted;
    } else {
      const priceSpan = priceWrap.querySelector('.t4s-price__sale') || priceWrap;
      const textNodes = [];
      priceSpan.childNodes.forEach((n) => {
        if (n.nodeType === Node.TEXT_NODE && n.textContent.trim()) textNodes.push(n);
      });
      if (textNodes.length > 0) {
        textNodes[textNodes.length - 1].textContent = formatted;
      } else {
        priceSpan.textContent = formatted;
      }
    }
  }

  function syncHiddenFields(form) {
    const config = getConfig();
    if (!config) return;

    [1, 2, 3].forEach((n) => {
      const showKey = `show${n}`;
      if (config[showKey] === false) return;

      const cb = form.querySelector(`[data-ostap-po-checkbox="${n}"]`);
      const hidden = form.querySelector(`[data-ostap-po-hidden="${n}"]`);
      if (!hidden) return;
      if (!cb) return;
      if (n === 3) {
        hidden.value = cb.checked ? serviceYesLabel(config) : NO;
      } else {
        hidden.value = cb.checked ? YES : NO;
      }
    });
  }

  function buildProperties(form, config) {
    syncHiddenFields(form);
    const props = {};
    const h1 = form.querySelector('[data-ostap-po-hidden="1"]');
    const h2 = form.querySelector('[data-ostap-po-hidden="2"]');
    const h3 = form.querySelector('[data-ostap-po-hidden="3"]');
    if (h1 && config.show1 !== false) props[config.prop1] = h1.value;
    if (h2 && config.show2 !== false) props[config.prop2] = h2.value;
    if (h3 && config.show3 !== false) props[config.prop3] = h3.value;
    return props;
  }

  function setSubmitLoading(form, loading) {
    const btn = form.querySelector('[data-atc-form]');
    if (!btn) return;
    btn.disabled = loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    const spinner = btn.querySelector('.t4s-loading__spinner');
    if (spinner) spinner.hidden = !loading;
  }

  function getSectionNames() {
    const isCartDisabled = window.T4Sconfigs?.cartType === 'disable';
    return isCartDisabled ? ['cart_data'] : ['cart_data', 'mini_cart'];
  }

  function renderCartSections(sections) {
    if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Cart) {
      if (sections && T4SThemeSP.Cart.renderContents) {
        T4SThemeSP.Cart.renderContents(sections);
      } else if (T4SThemeSP.Cart.getToFetch) {
        T4SThemeSP.Cart.getToFetch();
      }
    }
  }

  function openCartAfterAdd() {
    const drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;

    drawer.classList.remove('t4s-dn');
    drawer.setAttribute('aria-hidden', 'false');

    const overlay = document.querySelector('.t4s-close-overlay');
    if (overlay) overlay.classList.add('is--visible');
  }

  /**
   * Kalles product form has two name="id" controls:
   *   1) hidden <input name="id">  — often stale after ostap Farbe/Ecke clicks
   *   2) <select name="id">        — may also lag on products WITHOUT Ecke
   * Source of truth at ATC = checked Farbe (+ Ecke) radios in the form UI.
   */
  function checkedOptionValue(form, names) {
    const set = new Set(names.map(function (n) { return n.toLowerCase(); }));
    const inputs = form.querySelectorAll('input.t4s-swatch-input:checked');
    for (let i = 0; i < inputs.length; i++) {
      const name = (inputs[i].name || '').toLowerCase();
      if (set.has(name)) return String(inputs[i].value || '').trim();
    }
    // Fallback: selected swatch label
    for (let i = 0; i < names.length; i++) {
      const opt = form.querySelector(
        '[data-swatch-option].is-t4s-name__' + names[i] + ' [data-swatch-item].is--selected, ' +
        '[data-swatch-option].is-t4s-name__' + names[i].charAt(0).toUpperCase() + names[i].slice(1) + ' [data-swatch-item].is--selected'
      );
      if (opt && opt.dataset.value) return String(opt.dataset.value).trim();
    }
    return '';
  }

  function matchVariantFromSelect(select, farbe, ecke) {
    if (!select || !farbe) return '';
    const f = farbe.toLowerCase();
    const e = ecke ? ecke.toLowerCase() : '';
    const options = select.options || [];

    // Keep current Maße / 3rd option token when present (e.g. "Abriamo 01 / 240cm")
    let keepExtra = '';
    if (select.selectedOptions && select.selectedOptions[0]) {
      const curParts = (select.selectedOptions[0].textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(/\s*\/\s*/);
      if (!e && curParts.length >= 2) keepExtra = curParts[curParts.length - 1].toLowerCase();
      if (e && curParts.length >= 3) keepExtra = curParts[2].toLowerCase();
    }

    let fallbackId = '';
    for (let i = 0; i < options.length; i++) {
      if (options[i].disabled) continue;
      const text = (options[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      const parts = text.split(/\s*\/\s*/);
      const farbePart = (parts[0] || '').trim();
      if (farbePart !== f) continue;

      if (e) {
        const eckePart = (parts[1] || '').trim();
        if (eckePart !== e) continue;
        if (keepExtra && parts[2] && parts[2].trim() === keepExtra) {
          return String(options[i].value);
        }
        if (!fallbackId) fallbackId = String(options[i].value);
        continue;
      }

      // No Ecke: exact Farbe title, or Farbe + same Maße/extra
      if (parts.length === 1) return String(options[i].value);
      if (keepExtra && parts[1] && parts[1].trim() === keepExtra) {
        return String(options[i].value);
      }
      if (!fallbackId) fallbackId = String(options[i].value);
    }
    return fallbackId;
  }

  function resolveVariantId(form) {
    const select = form.querySelector('select[name="id"]');
    const farbe = checkedOptionValue(form, ['farbe', 'color', 'colour', 'couleur']);
    const ecke = checkedOptionValue(form, ['ecke', 'corner', 'seite']);

    // 1) UI selection wins (fixes no-Ecke products where select/hidden lag)
    let id = matchVariantFromSelect(select, farbe, ecke);

    // 2) select value if it already matches UI farbe
    if (!id && select && select.value) {
      const selText = ((select.selectedOptions[0] && select.selectedOptions[0].textContent) || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      if (!farbe || selText.indexOf(farbe.toLowerCase()) === 0) {
        id = String(select.value);
      }
    }

    // 3) hidden input last resort
    if (!id) {
      const hidden = form.querySelector('input[name="id"]');
      if (hidden && hidden.value) id = String(hidden.value);
    }

    if (id) {
      form.querySelectorAll('[name="id"]').forEach(function (el) {
        el.value = id;
        if (el.tagName === 'SELECT') {
          const opt = el.querySelector('option[value="' + id + '"]');
          if (opt) el.selectedIndex = opt.index;
        }
      });
    }
    return id;
  }

  async function addToCart(form, config) {
    const variantId = resolveVariantId(form);
    if (!variantId) return;

    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    const properties = buildProperties(form, config);

    const items = [
      {
        id: parseInt(variantId, 10),
        quantity,
        properties,
      },
    ];

    const serviceCb = form.querySelector('[data-ostap-po-checkbox="3"]');
    if (serviceCb?.checked && config.serviceVariantId) {
      items.push({
        id: parseInt(config.serviceVariantId, 10),
        quantity: 1,
        properties: {
          'Für Produkt': config.productTitle,
        },
      });
    }

    const routes = window.T4Sroutes || {};
    const url = (routes.cart_add_url || '/cart/add') + '.js';
    const sectionNames = getSectionNames();

    setSubmitLoading(form, true);
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items, sections: sectionNames }),
      });
      const data = await res.json();
      if (data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      if (typeof jQuery_T4NT !== 'undefined') {
        jQuery_T4NT(document).trigger('add:cart:success').trigger('add:cart:upsell');
      }

      if (typeof T4SThemeSP !== 'undefined') {
        T4SThemeSP.isATCSuccess = true;
      }

      renderCartSections(data.sections);
      openCartAfterAdd();
    } catch (err) {
      window.alert(err.message || err);
    } finally {
      setSubmitLoading(form, false);
    }
  }

  function bindForm(form) {
    const config = getConfig();
    if (!config || form.dataset.ostapPoBound === '1') return;
    form.dataset.ostapPoBound = '1';

    form.querySelectorAll('[data-ostap-po-checkbox]').forEach((cb) => {
      cb.addEventListener('change', () => {
        syncHiddenFields(form);
        updateDisplayedPrice(form, config);
      });
    });

    syncHiddenFields(form);

    const atcBtn = form.querySelector('[data-atc-form]');
    if (atcBtn) {
      atcBtn.addEventListener(
        'click',
        (e) => {
          if (!form.classList.contains('has-ostap-po')) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          addToCart(form, config);
        },
        true
      );
    }

    form.addEventListener(
      'submit',
      (e) => {
        if (!form.classList.contains('has-ostap-po')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCart(form, config);
      },
      true
    );
  }

  function init() {
    const form = document.querySelector('form.has-ostap-po[data-type="add-to-cart-form"]');
    if (!form) return;

    const buttonsWrap = form.querySelector('.t4s-product-form__buttons');
    if (buttonsWrap) buttonsWrap.classList.add('ostap-po--has-options');

    const config = getConfig();
    if (config) updateDisplayedPrice(form, config);
    bindForm(form);

    function onVariantChange() {
      setTimeout(() => {
        // Sync hidden input ← select / UI (Maße native path leaves input stale)
        try {
          resolveVariantId(form);
        } catch (e) {
          const select = form.querySelector('select[name="id"]');
          if (select && select.value) syncAllVariantIdFields(form, select.value);
        }
        const priceWrap = form.closest('[data-product-featured]')?.querySelector('[data-product-price]')
          || document.querySelector('[data-product-price]');
        if (priceWrap) delete priceWrap.dataset.ostapBasePrice;
        updateDisplayedPrice(form, getConfig());
        // Sticky ATC price block if present
        document.querySelectorAll('[data-product-price]').forEach(function (wrap) {
          if (wrap === priceWrap) return;
          delete wrap.dataset.ostapBasePrice;
        });
        const featured = form.closest('[data-product-featured]');
        if (featured) {
          featured.querySelectorAll('[data-product-price]').forEach(function () {
            updateDisplayedPrice(form, getConfig());
          });
        }
      }, 50);
    }

    if (typeof jQuery_T4NT !== 'undefined') {
      jQuery_T4NT(document).on('variant:changed', onVariantChange);
    }
    document.addEventListener('variant:changed', onVariantChange);
    // Stoff / Maße / Farbe / model — any swatch or id control must refresh price
    form.addEventListener(
      'change',
      function (e) {
        const t = e.target;
        if (!t) return;
        const isId = t.name === 'id' || (t.matches && t.matches('select[name="id"], input[name="id"]'));
        const isSwatch = t.matches && t.matches('input.t4s-swatch-input');
        if (isId || isSwatch) onVariantChange();
      },
      true
    );
    form.addEventListener(
      'click',
      function (e) {
        const item = e.target && e.target.closest && e.target.closest('[data-swatch-item], [data-ostap-stoff]');
        if (item) onVariantChange();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
